import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ChatAlertIcon({
  size,
  color,
  style,
  noFill,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      color={color}
      style={style}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.9222 15.6348V13.3504H1.4262C0.656802 13.3504 0.0332031 12.7219 0.0332031 11.9454V1.77094C0.0332031 0.99444 0.65682 0.36499 1.4262 0.36499H14.6402C15.4096 0.36499 16.0332 0.99444 16.0332 1.77094V11.9454C16.0332 12.7219 15.4096 13.3504 14.6402 13.3504H9.08557L5.06665 16.2264C4.58836 16.5742 3.9222 16.2268 3.9222 15.6348ZM4.9222 12.8461V15.0931L8.63687 12.4348C8.72142 12.3743 8.82253 12.3418 8.9262 12.3418H14.6402C14.8575 12.3418 15.0332 12.1647 15.0332 11.9454V1.77094C15.0332 1.55129 14.8571 1.37356 14.6402 1.37356H1.4262C1.20928 1.37356 1.0332 1.55129 1.0332 1.77094V11.9454C1.0332 12.1647 1.20891 12.3418 1.4262 12.3418H4.4222C4.69835 12.3418 4.9222 12.5676 4.9222 12.8461ZM8.5333 8.00322V2.72737C8.5333 2.44886 8.30945 2.22309 8.0333 2.22309C7.75716 2.22309 7.5333 2.44886 7.5333 2.72737V8.00322C7.5333 8.28173 7.75716 8.50751 8.0333 8.50751C8.30945 8.50751 8.5333 8.28173 8.5333 8.00322ZM8.0333 10.8141C7.6893 10.8141 7.4103 10.5327 7.4103 10.1858C7.4103 9.83882 7.6893 9.55743 8.0333 9.55743C8.3773 9.55743 8.6563 9.83882 8.6563 10.1858C8.6563 10.5327 8.3773 10.8141 8.0333 10.8141Z'
      />
    </svg>
  );
}
